import { render, staticRenderFns } from "./FillOutBaoGold.vue?vue&type=template&id=65abcb46&scoped=true&"
import script from "./FillOutBaoGold.vue?vue&type=script&lang=js&"
export * from "./FillOutBaoGold.vue?vue&type=script&lang=js&"
import style0 from "./FillOutBaoGold.vue?vue&type=style&index=0&id=65abcb46&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abcb46",
  null
  
)

export default component.exports